import { IsEnum, IsNumber, IsOptional, IsString } from 'class-validator';

export type OrderCancelReason = 'reopen' | 'refund';
export const OrderCancelReasons: OrderCancelReason[] = ['reopen', 'refund'];
export class OrderCancelRequestDto {
  @IsNumber()
  orderId: number;

  @IsNumber()
  @IsOptional()
  managerEmployeeId?: number;

  @IsString()
  @IsOptional()
  note?: string;

  @IsEnum(OrderCancelReasons)
  @IsOptional()
  reason?: OrderCancelReason;

  @IsString()
  @IsOptional()
  localStorageApiKey?: string;
}
